import { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';

import styles from './Navbar.module.css';
// import Logo from '../../assets/logo.png';

const Links = [
  { nome: 'Turismo', src: '/pontos-turisticos' },
  { nome: 'Mapa cultural', src: '/mapa-cultural' },
  { nome: 'Concurso de poesia', src: '/concurso-de-poesia' },
  { nome: 'Autores', src: '/autores' },
  { nome: 'História', src: '/historia' },
  { nome: 'Poesias', src: '/poesias' }
];

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const navRef = useRef(null);

  useEffect(() => {
    function handleClickOut(event) {
      if (menuOpen && navRef.current && !navRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    }

    document.addEventListener('mousedown', handleClickOut);

    return () => {
      document.removeEventListener('mousedown', handleClickOut);
    };
  }, [menuOpen]);

  return (
    <nav className={styles.navbar} ref={navRef}>
      <div className={styles.logo}>
        <Link to='/' className={styles.logoBlock}>
          <div className={styles.logoIcon}>T</div>
          <span className={styles.logoText}>Terra da Poesia</span>
        </Link>
      </div>

      <button
        className={`${styles.menuToggle} ${menuOpen ? styles.ativo : ''}`}
        onClick={() => setMenuOpen(!menuOpen)}
        aria-label={menuOpen ? "Fechar menu" : "Abrir menu"}
      >
        <span></span>
        <span></span>
        <span></span>
      </button>

      <ul className={`${styles.navLinks} ${menuOpen ? styles.aberto : ''}`}>
        {Links.map((link, index) => (
          <li key={index}>
            <Link to={link.src} onClick={() => setMenuOpen(false)}>
              {link.nome}
            </Link>
          </li>
        ))}
      </ul>

      <div className={styles.navActions}>
        <Link to="/mapa" className={styles.navButton}>Explorar Mapa</Link>
      </div>
    </nav>
  );
}
